import { ChakraComponent } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';

import locales from './locales';

interface OBFileItemProps {
  fileName: string;
  areButtonsDisabled?: boolean;
  isLoading?: boolean;
  onPreviewClick: () => void;
  onDeleteClick?: () => void;
}

/**
 * A component that shows a file item, with actions buttons to preview the file and delete the file
 */
const OBFileItem: ChakraComponent<'div', OBFileItemProps> = ({
  areButtonsDisabled,
  fileName,
  isLoading,
  onDeleteClick,
  onPreviewClick,
  ...props
}) => (
  <SunshineCard title={fileName} {...props}>
    <SunshineCard.Slot name="aside">
      <SquircleIcon name="file" />
    </SunshineCard.Slot>

    {onDeleteClick ? (
      <SunshineCard.Content>
        <Button
          isDisabled={areButtonsDisabled}
          isLoading={isLoading}
          marginTop="space-8"
          onClick={onDeleteClick}
          variant="inline-secondary"
        >
          {locales.delete}
        </Button>
      </SunshineCard.Content>
    ) : null}

    <SunshineCard.Slot name="action">
      <SunshineCard.SunshineIcon
        _hover={{ color: 'grey.500' }}
        cursor="pointer"
        name="eye-open"
        onClick={onPreviewClick}
        size="icon-24"
      />
    </SunshineCard.Slot>
  </SunshineCard>
);

export default OBFileItem;
